import { Controller } from "@hotwired/stimulus"

// Closes the parent DaisyUI dropdown when a click happens on an actionable item (link/button).
// Skips closing when clicking disabled items (span, or li.menu-disabled).
export default class extends Controller {
  close(event) {
    // Only close when clicking an actual link or button - not a disabled item (span)
    const linkOrButton = event.target.closest("a, button")
    if (!linkOrButton || !this.element.contains(linkOrButton)) return

    const dropdown = this.element.closest(".dropdown")
    if (!dropdown) return

    dropdown.classList.remove("dropdown-open")
    dropdown.querySelectorAll("[tabindex='0']").forEach((el) => el.blur())
    const active = document.activeElement
    if (active && dropdown.contains(active)) {
      active.blur()
    }
  }
}
